import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';
proj4.defs("EPSG:25832",
				"+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");

register(proj4)

function getCustomLayers() {
    return window.customLayers;
}

function getCustomMapOptions() {
    return window.customMapOptions;
}
function getContextPath() {
    return window.contextPath;
}
export default {
    getCustomLayers:getCustomLayers,
    getCustomMapOptions:getCustomMapOptions,
    getContextPath:getContextPath
}
